<template>
    <div class="con-list">
		<el-form>
			<ul>
				<li>
					<div class="inline-filed">
						<el-form-item
							label="缴纳地：">
							<div class="el-input">{{applyData.socialInsuranceLocationDescr}}</div>
						</el-form-item>
					</div>
					<div class="inline-filed switch-filed">
						<el-form-item
                            label="是否转正后缴纳公积金：">
							<el-switch
                                disabled
                                v-model="applyData.beRegularEmpPay"
                                active-color="#13ce66"
                                class="role-switch"
                                active-value="Y"
                                inactive-value="N"
                            ></el-switch>
						</el-form-item>
					</div>
				</li>
                <li>
					<div class="inline-filed">
						<el-form-item
							label="社保基数：">
							<div class="el-input">{{applyData.socialInsuranceBase | transferValue}}</div>
						</el-form-item>
					</div>
					<!-- <div class="inline-filed switch-filed">
						<el-form-item
                            label="是否只缴纳意外险：">
							<el-switch
                                disabled
                                v-model="applyData.accidentInsurance"
                                active-color="#13ce66"
                                class="role-switch"
                                active-value="Y"
                                inactive-value="N"
                            ></el-switch>
						</el-form-item>
					</div> -->
				</li>
                <li>
					<div class="inline-filed">
						<el-form-item
							label="公积金基数：">
							<div class="el-input">{{applyData.houseAccFundBaseMax}}</div>
						</el-form-item>
					</div>
					<!-- <div class="inline-filed switch-filed">
						<el-form-item
                            label="是否缴纳意外险加补充医疗：">
							<el-switch
                                disabled
                                v-model="applyData.accidentInsuranceMedicine"
                                active-color="#13ce66"
                                class="role-switch"
                                active-value="Y"
                                inactive-value="N"
                            ></el-switch>
						</el-form-item>
					</div> -->
				</li>
			</ul>
		</el-form>
	</div>
</template>

<script>
export default {
    name: 'socialInfo',
    props: ['applyData'],
    filters: {
        transferValue(value) {
            return {
                'MIN': '当地下限',
                'SAL': '按工资总额',
            }[value]
        },
	},
}
</script>
